module.exports = __webpack_public_path__ + "static/img/payment-cheque.ddfad28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/payment-cheque.png
// module id = 9GlZ
// module chunks = 0